var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"back-to-top",rawName:"v-back-to-top"}],staticClass:"btn-back-to-top",on:{"click":_vm.backToTop}},[_c('i',{staticClass:"iconfont icon-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }